import FallbackImageOptions from "%/dynamic-component-editor/bundles/fallback-image-options";
import FallbackImage from "%/dynamic-component-editor/options/fallback-image";
import {
  StandardImageElementMixin,
} from "%/dynamic-component-editor/standard-elements/image-element/standard-image-element-mixin";
import LinkAction from "%/dynamic-component-editor/options/link-action";
import { OptionMediaResolverMixin } from "%/dynamic-component-editor/mixins/option-media-resolver-mixin";

export const FallbackImageElementMixin = {
  mixins: [StandardImageElementMixin, OptionMediaResolverMixin],
  optionBundles: [
    FallbackImageOptions,
  ],
  options: [
    LinkAction,
  ],
  data() {
    return {
      FallbackImage,
    };
  },
  computed: {
    // Stored either as a media_id (resolved at render) or a legacy URL.
    imageMediaUnresolvable() {
      return this.isOptionMediaUnresolvable(this.getOptionValue(FallbackImage));
    },
    imageSrc() {
      return this.resolveOptionMedia(this.getOptionValue(FallbackImage));
    },
    fallbackImageSrc() {
      return this.resolveOptionMedia(this.getOptionValue(FallbackImage));
    },
  },
};
